import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import rootReducer from '@/rdx/reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/* eslint-disable no-underscore-dangle */
export default createStore(
  rootReducer /* preloadedState, */,
  composeEnhancers(applyMiddleware(thunkMiddleware)),
);
/* eslint-enable */
